import $ from 'jquery';
import Notifications from '../global/Notifications';
import outOfStockErrors from '../templates/outOfStockErrors.hbs';

/**
 * An object of selectors used in this file
 * @property SELECTORS
 * @type {Object}
 * @final
 */
const SELECTORS = {
    PLACE_ORDER_FORM: '.js-placeOrderForm',
    PRODUCT_TABLE_QTY_CELL: '.js-qtyCell',
    PLACE_ORDER_SUBMIT: '.js-place-order-submit'
};

const CLASSES = {
    SITE_MESSAGE_TYPE: 'input_squared--error'
}
/**
 * Control place order form
 * 
 *
 * @class CheckoutPlaceOrderView
 * @constructor
 */
export default class CheckoutPlaceOrderView {
    constructor($element) {
        this.$element = $element;
        return this.setupHandlers()
            .createChildren()
            .enable()
            .placeOrderValidation();
    }

    /**
     * SetupHandlers
     *
     * @method setupHandlers
     * @public
     * @chainable
     */
    setupHandlers() {
        this.onPlaceOrderSubmitHandler = this.placeOrderValidation.bind(this);
        return this;
    }

    /**
     * createChildren
     *
     * @method createChildren
     * @public
     * @chainable
     */
    createChildren() {
        this.$placeOrderForm = this.$element.find(SELECTORS.PLACE_ORDER_FORM);
        this.$cartTableQty = this.$element.find(SELECTORS.PRODUCT_TABLE_QTY_CELL);
        this.$placeOrderSubmit = this.$element.find(SELECTORS.PLACE_ORDER_SUBMIT);
        this.notifications = new Notifications();
        return this;
    }

    /**
     * Handle validations for the place order.
     * @method onParentClick
     * @public
     * @chainable
     */
    placeOrderValidation(e) {
        let nonAvailableProducts = [];
        if (this.$cartTableQty.length) {
            const products = this.$cartTableQty
            nonAvailableProducts = products.filter((_, product) => {
                const currentQty = parseInt(product.dataset.currentQty)
                const qtyInStock = parseInt(product.dataset.qtyInStock)
                const isOutOfStock = product.dataset.isOutOfStock.toLowerCase()  === 'true'

                if (isOutOfStock || currentQty > qtyInStock) {
                    $(product).addClass('u-textColorRedError')
                    return true;
                }
            })
            if (nonAvailableProducts.length) {
                this.notifications.showErrorNotification(outOfStockErrors({
                    message: NOTIFICATIONS.OUT_OF_STOCK_ERROR,
                    linkText: NOTIFICATIONS.EDIT_CART
                }), CLASSES.SITE_MESSAGE_TYPE)
                this.$placeOrderSubmit.attr('disabled', true);
                e && e.preventDefault();
            }
        }
        return true;
    }

    /**
     * Enable
     *
     * @method enable
     * @public
     * @chainable
     */
    enable() {
        this.$placeOrderSubmit.on('click submit', this.onPlaceOrderSubmitHandler);
        return this;
    }

    /**
     * Disable
     *
     * @method disable
     * @public
     * @chainable
     */
    disable() {
        this.$placeOrderSubmit.off('click submit', this.onPlaceOrderSubmitHandler);
        return this;
    }
}